<template>
  <div class="page">
    <div class="page-grid">
      <div class="page-container">
        <h2>Client Demographics</h2>
        <ClientDemographicsGraph
          class="page-graph-demographics"
          :clientDemographics="listing.client_demographics"
        />
      </div>

      <div class="page-container container-technology-use">
        <h2>Technology Use</h2>

        <div class="page-data-grid">
          <div
            v-for="technology in technologiesInUse"
            :key="technology.variable"
            class="page-data-item nested tech_padding">
            <CustomIcon
              :name="technology.icon"
              height="35" width="35"
              :color="'#97C131'"
            />
            <div>
              <label>{{ technology.title }}</label>
              <span>{{ listing[technology.variable] }}</span>
            </div>
          </div>
        </div>


      </div>

      <div class="page-container container-comm-methods">
        <h2>Communication Methods</h2>

        <div class="page-data-grid data-grid-table">
          <div
            v-for="method in communicationUsed"
            :key="method.variable"
            class="page-data-item nested">
            <img :src="method.icon" v-bind:class="{ 'icon-true': method.bool, 'icon-false': !method.bool }"/>
            <label>{{ method.label }}</label>
          </div>
        </div>

        <div class="d-flex justify-center communiations_legend">
          <div class="d-inline mt-2 mr-4 communiations_legend_box"></div>
          <div class="d-inline">Methods used are marked green.</div>
        </div>
      </div>


      <div class="page-container container-meeting-freq">
        <div class="meeting-frequency-wrapper"> <!-- #97C131 -->
          <div style="z-index: 9; position: absolute; top: 70px; right: 350px">
            <div style="width: 9px; height: 9px; background-color: #97C131; margin-left: 30px; margin-top: -5px;"></div>
            <div style="width: 30px; height: 57px; border-top: 1px solid #97C131; border-left: 1px solid #97C131; margin-top: -5px;"></div>
            <div style="width: 30px; border-bottom: 1px solid #97C131; margin-left: -29px;"></div>
            <div style="width: 9px; height: 9px; background-color: #97C131; margin-left: -38px; margin-top: -5px;"></div>
          </div>

          <h2>Meeting Frequency</h2>

          <MeetingFrequencyGraph
            class="page-graph-meetings"
            :meetingsAtPrimaryOffice="listing.comm_face_primary_office"
            :meetingsAtSecondaryOffice="listing.comm_face_secondary_office"
            :meetingsAtClientHome="listing.comm_face_clients_home"
            :meetingsAtClientOffice="listing.comm_face_clients_office"
          />

          <div class="meeting-frequency-labels">
            <div
              v-if="+listing.comm_face_primary_office > 0"
              class="page-data-item nested"
            >
              <div class="box" style="background-color: #97C932;"></div>
              <span>{{ listing.comm_face_primary_office || 0 }}%</span>
              <label>Primary Office</label>
            </div>

            <div
              v-if="+listing.comm_face_secondary_office > 0"
              class="page-data-item nested"
            >
              <div class="box" style="background-color: #0093A3;"></div>
              <span>{{ listing.comm_face_secondary_office || 0 }}%</span>
              <label>Secondary Office</label>
            </div>

            <div
              v-if="+listing.comm_face_clients_home > 0"
              class="page-data-item nested"
            >
              <div class="box" style="background-color: #5E5E60;"></div>
              <span>{{ listing.comm_face_clients_home || 0 }}%</span>
              <label>Client's Home</label>
            </div>

            <div
              v-if="+listing.comm_face_clients_office > 0"
              class="page-data-item nested"
            >
              <div class="box" style="background-color: #E55440;"></div>
              <span>{{ listing.comm_face_clients_office || 0 }}%</span>
              <label>Client's Office</label>
            </div>
          </div>

          <div class="page-data-card-box">
            <v-icon size="40" color="white" class="d-inline mb-1">mdi-map-marker</v-icon>
            <div class="d-inline mx-2">
              <div class="d-block">
                <span class="d-block font-weight-black">Meetings:</span>
                <span class="d-block font-weight-light">{{ listing.comm_face_meeting_frequency }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <BottomColorBar />
  </div>
</template>

<script>
import BottomColorBar from './partials/BottomColorBar'
import ClientDemographicsGraph from './partials/ClientDemographicsGraph'
import MeetingFrequencyGraph from './partials/MeetingFrequencyGraph'

import IconCards from './assets/comm-cards.svg'
import IconEmails from './assets/comm-emails.svg'
import IconEvents from './assets/comm-events.svg'
import IconFace from './assets/comm-face.svg'
import IconNewsletters from './assets/comm-newsletters.svg'
import IconOther from './assets/comm-other.svg'
import IconPhone from './assets/comm-phone.svg'
import IconSocial from './assets/comm-social.svg'
import IconVideo from './assets/comm-video.svg'

export default {
  name: 'PdfPage5',
  components: {
    BottomColorBar,
    ClientDemographicsGraph,
    MeetingFrequencyGraph,
  },
  props: {
    listing: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    communicationMethods: [
      {
        label: 'Newsletter',
        variable: 'comm_methods_newsletter',
        icon: IconNewsletters,
      },
      {
        label: 'Face-to-Face Meetings',
        variable: 'comm_methods_face_meetings',
        icon: IconFace,
      },
      {
        label: 'Phone Calls',
        variable: 'comm_methods_phone_calls',
        icon: IconPhone,
      },
      {
        label: 'Emails',
        variable: 'comm_methods_emails',
        icon: IconEmails,
      },
      {
        label: 'Occasion Cards',
        variable: 'comm_methods_occasion_cards',
        icon: IconCards,
      },
      {
        label: 'Video Conference',
        variable: 'comm_methods_video_conferencing',
        icon: IconVideo,
      },
      {
        label: 'Social Media',
        variable: 'comm_methods_social_media',
        icon: IconSocial,
      },
      {
        label: 'Clients Events',
        variable: 'comm_methods_client_events',
        icon: IconEvents,
      },
      {
        label: 'Other',
        variable: 'comm_methods_other',
        icon: IconOther,
      },
    ],

    technologies: [
      {
        title: 'CRM',
        variable: 'tech_crm',
        icon: 'srg-comments',
      },
      {
        title: 'Financial Planning',
        variable: 'tech_financial_planning',
        icon: 'srg-planning-docs',
      },
      {
        title: 'Portfolio Rebalancing',
        variable: 'tech_portfolio_rebalancing',
        icon: 'srg-prospectus',
      },
      {
        title: 'Document Management',
        variable: 'tech_document_management',
        icon: 'srg-document-management',
      },
      {
        title: 'Account Aggregation',
        variable: 'tech_account_aggregation',
        icon: 'srg-account-aggregation',
      },
      {
        title: 'Accounting',
        variable: 'tech_accounting',
        icon: 'srg-gears',
      },
      {
        title: 'Other',
        variable: 'tech_other',
        icon: 'srg-tech-cloud',
      },
    ],
  }),

  computed: {
    communicationUsed () {
      return this.communicationMethods
        .map((method) => {
          return {
            bool: this.listing[method.variable],
            ...method
          };
        });
    },

    technologiesInUse () {
      return this.technologies
        .filter(({ variable }) => this.listing[variable])
    },
  },
}
</script>

<style scoped>
.page-grid {
  width: 100%;
  height: 100%;
  padding: 30px 10px;

  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
}

.icon-true {
  -webkit-filter: unset;
  -moz-filter: unset;
  -ms-filter: unset;
  -o-filter: unset;
  opacity: 1;
}

.icon-false {
  -webkit-filter: grayscale(100%);
    -moz-filter:    grayscale(100%);
    -ms-filter:     grayscale(100%);
    -o-filter:      grayscale(100%);
  opacity: .25;
}

.page-container {
  position: relative;
  padding: 10px 20px;
  border: 2px solid transparent;
}

.page-container.container-technology-use .page-data-grid {
  grid-row-gap: 7px;
}

.page-container:nth-child(1)::after {
  content: '';
  position: absolute;
  top: 10px;
  right: -1px;
  bottom: 10px;
  width: 2px;
  background-color: #F2F2F2;
}

.page-container:nth-child(3)::after,
.page-container:nth-child(4)::after {
  content: '';
  position: absolute;
  top: 0;
  left: 10px;
  right: 10px;
  height: 2px;
  background-color: #F2F2F2;
}

.page-graph-demographics {
  width: 350px;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

h3 {
  margin: 30px 0 0;
}

.page .data-grid-table {
  justify-content: flex-start;
  grid-auto-flow: row;
  grid-auto-rows: 60px;
}

.page .data-grid-table .page-data-item {
  border-bottom: 2px solid #F2F2F2 !important;
}

.page-data-item.nested {
  grid-template-columns: 40px 1fr;
  grid-column-gap: 10px;
  align-items: center;
}

.container-comm-methods,
.container-meeting-freq {
  padding-top: 40px;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
}

.meeting-frequency-wrapper {
  grid-row-start: 1;
  grid-row-end: 3;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  padding: 13px 28px 28px;
  background-color: #97C13133;
}

.meeting-frequency-wrapper h2 {
  margin-bottom: 0;
}

.tech_padding  {
  margin: 7px 0;
}

.page-data-card-box {
  width: 100%;
  padding: 30px 0;
  justify-content: center;
}

.communiations_legend {
  padding: 2px 1px;
  background-color: #EFEFEF;
}

.communiations_legend_box {
  width: 8px; 
  height: 8px;
  background-color: #97C131;
}

.page-data-card-box span {
  /* flex-grow: 0; */
  text-align: left;
  font-size: .9rem !important;
}

.page-graph-meetings {
  position: relative;
  height: 250px;
  width: 270px;
}

.meeting-frequency-labels {
  width: 100%;
  margin-top: -10px;
  margin-bottom: 10px;
  padding-left: 30px;

  display: grid;
  grid-row-gap: 5px;
  grid-template-columns: 1fr;
  grid-template-rows: auto;
}

.meeting-frequency-labels .page-data-item.nested {
  grid-template-columns: 20px 35px 1fr;
}
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/PdfPage5.vue